import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/fleet-task',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/fleet-task',
    data,
  })

  return response?.data
}

export const update = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task/${fleetTaskId}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/fleet-task/delete',
    data,
  })

  return response?.data
}

export const trackFO = async (id) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/track/${id}`,
  })

  return response?.data
}

export const intervention = async (id, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${id}/intervention`,
    data,
  })

  return response?.data
}
